import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import setOperatorStatus from "~/operatorApplication/ts/service/status/SetOperatorStatus";
import {OPERATOR_STATUS_OFFLINE, OPERATOR_STATUS_ONLINE, OperatorStatus} from "~/chat/ts/data/OperatorStatus";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";

let interval: any;

export default class AutoAfk {
    private static statusBeforeAutoAway: OperatorStatus = OPERATOR_STATUS_ONLINE;
    private static customStatusBeforeAutoAway: string = null;

    private static locked: boolean = false;

    private static async lockAndMake(callback: () => Promise<any>) {
        if (!this.locked) {
            this.locked = true;
            try {
                await callback();
            } catch (e) {
            }
            this.locked = false;
        }
    }

    public static async wakeUp() {
        this.lockAndMake(async () => {
            if (OperatorAccountStore.isAutoAway.value) {
                let error = await setOperatorStatus(this.statusBeforeAutoAway, this.customStatusBeforeAutoAway, true);
                if (!error) {
                    OperatorAccountStore.setAutoAway(false);
                }
            }
        })

    }

    private static async goAway() {
        this.lockAndMake(async () => {
            this.statusBeforeAutoAway = OperatorAccountStore.storedStatusId.value;
            this.customStatusBeforeAutoAway = OperatorAccountStore.storedCustomStatusId.value;
            let error = await setOperatorStatus(OPERATOR_STATUS_OFFLINE, null, true);
            if (!error) {
                OperatorAccountStore.setAutoAway(true);
            }
        });
    }

    public static init() {
        clearInterval(interval);
        interval = setInterval(async () => {
            if (OperatorAccountStore.isAuthorized.value && OperatorApplicationPlatform.isSystemIdleStateAvailable) {
                let awayOnAfk = OperatorApplicationConfigInstance.isAutoAwayOnAfkEnabled;
                let awayOnLock = OperatorApplicationConfigInstance.isAutoAwayOnLockEnabled;
                let away = false;
                let idleThreshold = OperatorApplicationConfigInstance.autoAwayOnAfkIdleThreshold;
                if (awayOnLock) {
                    let state = await OperatorApplicationPlatform.getSystemIdleState(idleThreshold);
                    away = state == "locked" || (state == "idle" && awayOnAfk);
                } else if (awayOnAfk) {
                    let idleTime = await OperatorApplicationPlatform.getSystemIdleTime();
                    away = idleTime >= idleThreshold;
                }

                if (away) {
                    if (OperatorAccountStore.status.value.id != OPERATOR_STATUS_OFFLINE) {
                        this.goAway();
                    }
                } else {
                    this.wakeUp();
                }
            }
        }, 1000)
    }
}